module.exports = __webpack_public_path__ + "img/reserved.ac5cec6c.svg";